import type { RouteObject } from 'react-router-dom';

/**
 * Back-office : routes explicites (pas de « admin/* ») pour laisser
 * /admin/campagnes, /admin/bibliotheque et /admin/moderation aux modules concernés.
 * Toutes sont rendues dans AdminLayout (barre latérale, contrôle des rôles du back-office).
 */
export const backofficeRoutes: RouteObject[] = [
  { path: 'admin', lazy: () => import('./AdminHomePage').then((m) => ({ Component: m.AdminHomePage })) },
  { path: 'admin/zakat', lazy: () => import('./ZakatAdminPage').then((m) => ({ Component: m.ZakatAdminPage })) },
  { path: 'admin/transactions', lazy: () => import('./TransactionsPage').then((m) => ({ Component: m.TransactionsPage })) },
  { path: 'admin/exports', lazy: () => import('./ExportsPage').then((m) => ({ Component: m.ExportsPage })) },
  { path: 'admin/audit', lazy: () => import('./AuditPage').then((m) => ({ Component: m.AuditPage })) },
  { path: 'admin/utilisateurs', lazy: () => import('./UsersPage').then((m) => ({ Component: m.UsersPage })) },
  { path: 'admin/parametres', lazy: () => import('./SettingsPage').then((m) => ({ Component: m.SettingsPage })) },
];
